import { FormikErrors } from 'formik';
import { getTrans } from 'modules/i18n';
import { HardSkillEntry } from 'utils/cv-form-db';
import { isRequired } from '../../utils';

export const validateHardSkill = (hardSkill: HardSkillEntry) => {
  const errors: FormikErrors<HardSkillEntry> = {};

  const fieldsToValidate = [
    {
      field: 'name',
      message: getTrans('cvBuilderPage.hardSkill.form.name.required.label')
    },
    {
      field: 'level',
      message: getTrans('cvBuilderPage.hardSkill.form.level.required.label')
    }
  ] as const;

  fieldsToValidate.forEach(({ field, message }) => {
    if (isRequired(hardSkill[field as keyof HardSkillEntry] as string)) {
      errors[field] = message;
    }
  });

  return errors;
};

export const isHardSkillsComplete = (values: HardSkillEntry) => {
  const errors = validateHardSkill(values);
  return Object.keys(errors).length === 0;
};
